import React from 'react';
import PropTypes from 'prop-types';
import CreditInformationItem from 'components/Credit24/SelfService/CreditInformation/CreditInformationItem';
import { fromCents } from 'utils/helpers';

const propTypes = {
  upgrade: PropTypes.object,
};

const InformationStep = ({ upgrade }) => {
  const { product, predictedES } = upgrade;
  const mainCreditInformationItems = [
    {
      id: 'newCreditLimit',
      value: fromCents(product.principal),
      valueMod: 'limit',
    },
    {
      id: 'newMmp',
      value: fromCents(predictedES.mmp),
      valueMod: 'mmp',
    },
  ];

  const creditInformationItems = [
    {
      id: 'annualInterest',
      value: product.annualInterest,
      style: 'percent',
    },
    {
      id: 'apr',
      value: product.apr,
      style: 'percent',
      isTitleTooltip: true,
    },
    {
      id: 'withdrawalFixedFee',
      value: fromCents(product.invoicingFee),
    },
    {
      id: 'drawFeePercentage',
      value: product.drawFeePercentage,
      style: 'percent',
    },
  ];

  return (
    <div className="content-block">
      <div className="grid">
        <div className="grid__item one-half palm-one-whole">
          <div className="credit-info credit-info--main">
            {mainCreditInformationItems.map(({ id, ...rest }) => (
              <CreditInformationItem key={id} id={id} {...rest} />
            ))}
          </div>
        </div>
        <div className="grid__item one-half palm-one-whole">
          <div className="credit-info">
            {creditInformationItems.map(({ id, ...rest }) => (
              <CreditInformationItem key={id} id={id} {...rest} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

InformationStep.propTypes = propTypes;

export default InformationStep;
